<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      cell-class-name="align-top"
      row-id="amzReplenishmentDetailCode"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displaySku="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          label="SIZE"
          labelKey="table_label_goodsSize"
          :value="row.goodsSize"
        />
        <TableLabel
          label="分类"
          labelKey="table_label_masterCategoryName"
          :value="row.masterCategoryName"
        />
        <TableLabel
          label="SKU"
          labelKey="table_label_amzSkuNo"
          :value="row.amzSkuNo"
          primary
        />
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-1">
            <TableLabel
              v-if="isVc === 'Y'"
              label="VC PO"
              labelKey="table_label_vcPo"
              :value="row.vcPo"
              primary
            />
          </div>
          <div>
            <el-tag
              v-if="row.skuSalesChannel === 'V'"
              size="mini"
              type="warning"
            >
              {{ row.v_skuSalesChannel }}
            </el-tag>
          </div>
        </div>
      </template>
      <template v-slot:displayStore="{ row }">
        <TableLabel
          label="店铺"
          labelKey="table_label_invStoreName"
          :value="row.invStoreName"
        />
        <TableLabel
          label="Store SKU"
          labelKey="table_label_amzSkuStoreNo"
          :value="row.amzSkuStoreNo"
          primary
        />
        <TableLabel
          label="ASIN"
          labelKey="table_label_asinCode"
          :value="row.asinCode"
          primary
        />
        <TableLabel
          label="FNSKU"
          labelKey="table_label_fnskuCode"
          :value="row.fnskuCode"
          primary
        />
        <TableLabel
          label="UPC"
          labelKey="table_label_upc"
          :value="row.upc"
          primary
        />
        <TableLabel
          label="运营"
          labelKey="table_label_operateName"
          :value="row.operateName"
          primary
        />
        <el-tag
          v-if="row.v_storeSkuStatus"
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus }}
        </el-tag>
      </template>

      <template v-slot:displaySubmitQty="{ row }">
        <TableLabel
          label="补货数量"
          labelKey="table_label_submitQty"
          :value="row.submitQty || '0'"
          primary
        />
        <TableLabel
          label="装箱入数"
          labelKey="table_label_unitInBox"
          :value="row.unitInBox"
        />
        <TableLabel
          label="补货箱数"
          labelKey="table_label_ctnQty"
          :value="row.submitQty / row.unitInBox"
          primary
        />
      </template>

      <template v-slot:displayOperate="{ row }">
        <TableLabel
          label="预计上架日期"
          labelKey="table_label_etaDate"
          :value="row.etaDate"
        />
        <TableLabel
          label="中途断货天数"
          labelKey="table_label_halfwayOutageDays"
          :value="row.halfwayOutageDays || '0'"
        />
        <TableLabel
          label="实际日销售量"
          labelKey="table_label_advQtyBeforeRepPerDay"
          :value="row.advQtyBeforeRepPerDay || '0'"
        />
        <TableLabel
          label="到货日预估日销"
          labelKey="table_label_soldQtyAfterRepPerDay"
          :value="row.soldQtyAfterRepPerDay || '0'"
        />
        <TableLabel
          label="到货日活动销量"
          labelKey="table_label_advQtyAfterRepPerDay"
          :value="row.advQtyAfterRepPerDay || '0'"
        />
      </template>

      <template v-slot:displayReply="{ row }">
        <div class="d-flex">
          <div style="min-width:50%;max-width:50%;" class="pr-2">
            <div v-if="['Y', 'P'].includes(row.restockStatus)" class="mb-1">
              <TableLabel
                label="订单号"
                labelKey="table_label_displayPoNo"
                :value="row.displayPoNo"
                primary
              />
              <TableLabel
                label="出货数量"
                labelKey="table_label_invQty"
                :value="row.invQty"
                :valueStyle="{ color: '#409EFF', 'font-size': '14px' }"
              />
              <TableLabel
                label="缺货数量"
                labelKey="table_label_shortageQty"
                :value="row.shortageQty"
                :valueStyle="{ color: 'red', 'font-size': '14px' }"
              />
              <TableLabel
                label="产装日期"
                labelKey="table_label_displayFactoryDate"
                :value="row.displayFactoryDate"
              />
            </div>
            <el-tag
              v-if="row.v_restockStatus"
              size="mini"
              effect="dark"
              class="mr-1"
              :type="
                row.restockStatus === 'O'
                  ? 'danger'
                  : row.restockStatus === 'P'
                  ? 'warning'
                  : 'success'
              "
            >
              {{ row.v_restockStatus }}
            </el-tag>
            <el-tag
              v-if="row.replysStatus && row.replysStatus !== 'N'"
              size="mini"
              :type="
                row.replysStatus === 'B'
                  ? 'danger'
                  : row.replysStatus === 'S'
                  ? 'warning'
                  : row.replysStatus === 'Y'
                  ? 'success'
                  : ''
              "
            >
              {{ row.v_replysStatus }}
            </el-tag>

            <div class="mt-2" v-if="row.rejectReason">
              <TableLabel
                label="建议出货数量"
                labelKey="table_label_actualQty"
                :value="row.actualQty"
                :valueStyle="{ color: 'red', 'font-size': '14px' }"
              />
              <el-link
                type="danger"
                :underline="false"
                style="font-size: 13px;"
                @click="showRejectReason(row)"
              >
                {{ $l('btn_showRejectReason') || '查看运营反馈信息' }}
              </el-link>
            </div>
          </div>
          <div v-if="['Y', 'P'].includes(row.restockStatus)">
            <TableLabel
              label="NC"
              labelKey="table_label_displayNcNo"
              :value="row.displayNcNo"
            />
            <TableLabel
              label="出货工厂"
              labelKey="table_label_displayScmName"
              :value="row.displayScmName"
            />
            <TableLabel
              label="出货仓库"
              labelKey="table_label_displayWarehouseName"
              :value="row.displayWarehouseName"
            />
            <TableLabel
              label="开票工厂"
              labelKey="table_label_displayInvoiceFactoryName"
              :value="row.displayInvoiceFactoryName"
            />
            <TableLabel
              label="送货工厂"
              labelKey="table_label_displayShippingFactoryName"
              :value="row.displayShippingFactoryName"
            />
          </div>
        </div>
      </template>

      <template v-slot:opt="{ row }">
        <div
          style="text-align: center"
          v-if="!row.replysStatus || ['N', 'B'].includes(row.replysStatus)"
        >
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableOpts: tableOpts(this),
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
  },
  watch: {
    isVc() {
      this.$refs.skuTable.refreshColumn()
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return
      switch (menuType) {
        case 'replyEdit':
          this.$emit('openReplyEdit', data)
          break
        case 'submit':
          this.$emit('submit', [data.amzReplenishmentDetailCode])
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.skuTable.clearCheckboxRow()
      this.$refs.skuTable.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.skuTable
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    showRejectReason({ rejectReason }) {
      this.$alert(
        rejectReason,
        this.$l('alert_showRejectReason') || '反馈信息',
        {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
        }
      )
    },
  },
}
</script>
